import { L } from '@execonline-inc/translations';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { ScheduledProgramInstanceOption } from '../../../../../../../Types';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import { utcDateToLocalDate } from '../../../../../../Functions';

interface Props {
  scheduledOption: ScheduledProgramInstanceOption;
  experienceStore: LearningDesignExperienceStore;
  selectable: boolean;
}

const handleSelectedIdChange = (
  experienceStore: LearningDesignExperienceStore,
  scheduledOption: ScheduledProgramInstanceOption,
) => {
  const previouslySelectedIds = [
    ...experienceStore.previouslySelectedIds,
    ...experienceStore.selectedIds,
  ];
  experienceStore.setPreviouslySelectedIds(previouslySelectedIds);
  const selectedIds = experienceStore.selectedIds.includes(scheduledOption.id)
    ? experienceStore.selectedIds.filter((id) => id !== scheduledOption.id)
    : [...experienceStore.selectedIds, scheduledOption.id];
  experienceStore.setSelectedIds(selectedIds);
};

function DateCheckbox({ scheduledOption, experienceStore, selectable }: Props) {
  return (
    <label className="flex mt-4 items-center w-fit">
      <input
        className={clsx({
          'h-5 w-5 text-teal-600 mr-2 rounded': true,
          'cursor-pointer': selectable,
          'opacity-50 cursor-default bg-gray-200': !selectable,
        })}
        disabled={!selectable}
        type="checkbox"
        name="Add Program"
        checked={experienceStore.selectedIds.includes(scheduledOption.id)}
        onChange={() => handleSelectedIdChange(experienceStore, scheduledOption)}
      />
      <L
        localizeable={utcDateToLocalDate(scheduledOption.startOn)}
        format={'long-weekday-month-year'}
      />
    </label>
  );
}

export default observer(DateCheckbox);
